<template>
 <router-view></router-view>
 <ToastHost/>

</template>

<script>
import ToastHost from "@/components/toast-host.vue";

export default {
  name: 'App',
  components: {
    ToastHost,
  }
}
</script>
